(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best_seller"] && !Shopify.designMode) return;
  try {
    
    // Defer Swiper initialization for better performance
    function initBestSellerSliders() {
      // Desktop carousel
      var desktopSwiper = new Swiper(".best-seller-desktop-slider", {
        slidesPerView: 4,
        spaceBetween: 16,
        loop: false,
        lazy: {
          loadPrevNext: true,
        },
        navigation: {
          nextEl: ".best-seller-next-btn",
          prevEl: ".best-seller-prev-btn",
        },
        breakpoints: {
          1024: {
            slidesPerView: 4,
            spaceBetween: 16,
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 16,
          },
        },
      });

      // Mobile carousel
      var mobileSwiper = new Swiper(".best-seller-slider", {
        slidesPerView: 2,
        spaceBetween: 16,
        lazy: {
          loadPrevNext: true,
        },
        navigation: {
          nextEl: ".best-seller-mobile-next-btn",
          prevEl: ".best-seller-mobile-prev-btn",
        },
        breakpoints: {
          320: {
            slidesPerView: 2,
            spaceBetween: 16,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 16,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 16,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 16,
          },
        },
      });
    }
    
    // Initialize after DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        requestAnimationFrame(initBestSellerSliders);
      });
    } else {
      requestAnimationFrame(initBestSellerSliders);
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-slider-custom-new"] && !Shopify.designMode) return;
  try {
    
(function () {
  function waitForSwiper(cb) {
    var attempts = 0;
    var id = setInterval(function () {
      attempts++;
      if (window.Swiper) {
        clearInterval(id);
        cb();
      } else if (attempts > 50) {
        clearInterval(id);
        console.error('Swiper not found. Make sure the Swiper script is loaded before this section script.');
      }
    }, 100);
  }

  window._collectionSliders = window._collectionSliders || {};

  function initCollectionSliderForSection(sectionEl) {
    if (!sectionEl) return;

    var sectionId = sectionEl.dataset.sectionId || sectionEl.dataset.id || null;
    var key = sectionId || Array.prototype.indexOf.call(document.querySelectorAll('.collection-slider'), sectionEl);

    if (window._collectionSliders[key] && window._collectionSliders[key].destroy) {
      try {
        window._collectionSliders[key].destroy(true, true);
      } catch (err) {
        console.warn('Error destroying previous swiper instance:', err);
      }
      delete window._collectionSliders[key];
    }

    var swiperEl = sectionEl.querySelector('.custom-collection-slider-swiper');
    if (!swiperEl) return;

    var nextBtn = sectionEl.querySelector('.custom-collection-slider-next');
    var prevBtn = sectionEl.querySelector('.custom-collection-slider-prev');
    var scrollbarEl = sectionEl.querySelector('.custom-collection-scrollbar');

    var config = {
      slidesPerView: 1.5,
      spaceBetween: 16,
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      centeredSlides: false,
      breakpoints: {
        320: { slidesPerView: 1.5, spaceBetween: 16 },
        640: { slidesPerView: 2, spaceBetween: 16 },
        768: { slidesPerView: 3, spaceBetween: 16 },
        1024: { slidesPerView: 4, spaceBetween: 16 }
      }
    };

    if (scrollbarEl) {
      config.scrollbar = { el: scrollbarEl, draggable: true };
    }

    if (nextBtn && prevBtn) {
      config.navigation = { nextEl: nextBtn, prevEl: prevBtn };
    }

    try {
      var instance = new Swiper(swiperEl, config);
      window._collectionSliders[key] = instance;
    } catch (err) {
      console.error('Failed to initialize Swiper for section', key, err);
    }
  }

  function initAll() {
    document.querySelectorAll('.collection-slider').forEach(function (el) {
      initCollectionSliderForSection(el);
    });
  }

  waitForSwiper(function () {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      initAll();
    });

    document.addEventListener('shopify:section:unload', function (e) {
      var sid = e.detail && e.detail.sectionId;
      if (sid && window._collectionSliders && window._collectionSliders[sid]) {
        try {
          window._collectionSliders[sid].destroy(true, true);
        } catch (err) {
          /* ignore */
        }
        delete window._collectionSliders[sid];
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-slider-custom"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Wait for Swiper to exist (timeout after ~5s)
  function waitForSwiper(cb) {
    var attempts = 0;
    var id = setInterval(function () {
      attempts++;
      if (window.Swiper) {
        clearInterval(id);
        cb();
      } else if (attempts > 50) {
        clearInterval(id);
        console.error('Swiper not found. Make sure the Swiper script is loaded before this section script.');
      }
    }, 100);
  }

  // store instances here
  window._collectionSliders = window._collectionSliders || {};

  function initCollectionSliderForSection(sectionEl) {
    if (!sectionEl) return;

    // Use data-section-id if present, otherwise generate key from element index
    var sectionId = sectionEl.dataset.sectionId || sectionEl.dataset.id || sectionEl.getAttribute('data-id') || null;
    var key = sectionId || Array.prototype.indexOf.call(document.querySelectorAll('.collection-slider'), sectionEl);

    // If already initialized, destroy first
    if (window._collectionSliders[key] && window._collectionSliders[key].destroy) {
      try {
        window._collectionSliders[key].destroy(true, true);
      } catch (err) {
        console.warn('Error destroying previous swiper instance:', err);
      }
      delete window._collectionSliders[key];
    }

    var swiperEl = sectionEl.querySelector('.custom-collection-slider-swiper');
    if (!swiperEl) {
      return;
    }

    var nextBtn = sectionEl.querySelector('.custom-collection-slider-next');
    var prevBtn = sectionEl.querySelector('.custom-collection-slider-prev');
    var scrollbarEl = sectionEl.querySelector('.custom-collection-scrollbar');

    // Build config - exact same as product slider
    var config = {
      slidesPerView: 1.5,
      spaceBetween: 16,
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      centeredSlides: false,
      breakpoints: {
        320: { slidesPerView: 1.5, spaceBetween: 16 },
        640: { slidesPerView: 2, spaceBetween: 16 },
        768: { slidesPerView: 3, spaceBetween: 16 },
        1024: { slidesPerView: 4, spaceBetween: 16 }
      }
    };

    if (scrollbarEl) {
      config.scrollbar = { el: scrollbarEl, draggable: true };
    }

    // For navigation, pass DOM elements (scoped to this section)
    if (nextBtn && prevBtn) {
      config.navigation = { nextEl: nextBtn, prevEl: prevBtn };
    }

    try {
      var instance = new Swiper(swiperEl, config);
      window._collectionSliders[key] = instance;
    } catch (err) {
      console.error('Failed to initialize Swiper for section', key, err);
    }
  }

  function initAll() {
    document.querySelectorAll('.collection-slider').forEach(function (el) {
      initCollectionSliderForSection(el);
    });
  }

  // Boot sequence
  waitForSwiper(function () {
    // initialize on load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Shopify theme editor events (reinit / unload)
    document.addEventListener('shopify:section:load', function (e) {
      // e.detail.sectionId exists when Editor loads a single section
      // re-init everything to be safe; or you can target e.detail.sectionId
      initAll();
    });

    document.addEventListener('shopify:section:unload', function (e) {
      // destroy instance for removed section
      var sid = e.detail && e.detail.sectionId;
      if (sid && window._collectionSliders && window._collectionSliders[sid]) {
        try { window._collectionSliders[sid].destroy(true, true); } catch (err) { /* ignore */ }
        delete window._collectionSliders[sid];
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-slider"] && !Shopify.designMode) return;
  try {
    
    var swiper = new Swiper(".collection-slider-swiper", {
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: true,
      },
      
      navigation: {
        nextEl: ".collection-slider-next",
        prevEl: ".collection-slider-prev",
      },
      centeredSlides: false, 
       breakpoints: {
        320: {
          slidesPerView: 1.5,
          spaceBetween: 16,
        },
        640: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 16,
        },
      },
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-collection-slider"] && !Shopify.designMode) return;
  try {
    
    // Defer initialization for better performance
    function initCollectionSlider() {
      var swiper = new Swiper(".collection-slider-swiper", {
        scrollbar: {
          el: ".swiper-scrollbar",
          hide: true,
        },
        navigation: {
          nextEl: ".collection-slider-next",
          prevEl: ".collection-slider-prev",
        },
        lazy: {
          loadPrevNext: true,
        },
        centeredSlides: false, 
        breakpoints: {
          320: {
            slidesPerView: 1.5,
            spaceBetween: 16,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 16,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 16,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 16,
          },
        },
      });
    }
    
    // Initialize after DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        requestAnimationFrame(initCollectionSlider);
      });
    } else {
      requestAnimationFrame(initCollectionSlider);
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hourly-deals-timer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MONTHS = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

    // Offset in ms between UTC and `timeZone` at instant `utcMs`.
    function zoneOffset(utcMs, timeZone) {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: timeZone,
        hourCycle: 'h23',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      }).formatToParts(new Date(utcMs));
      var p = {};
      parts.forEach(function (part) {
        p[part.type] = parseInt(part.value, 10);
      });
      return Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second) - utcMs;
    }

    // Reads the date part of a lowercased value. Returns { y, m, d, rest } or null.
    function parseDatePart(value) {
      var m;
      if ((m = value.match(/^(\d{4})[-\/.](\d{1,2})[-\/.](\d{1,2})(.*)$/))) {
        return { y: +m[1], m: +m[2], d: +m[3], rest: m[4] };
      }
      if ((m = value.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})(.*)$/))) {
        return { y: +m[3], m: +m[1], d: +m[2], rest: m[4] };
      }
      if ((m = value.match(/^(?:[a-z]+ )?([a-z]{3,9})\.? (\d{1,2})(?:st|nd|rd|th)? (\d{4})(.*)$/))) {
        var month = MONTHS.indexOf(m[1].slice(0, 3)) + 1;
        return month ? { y: +m[3], m: month, d: +m[2], rest: m[4] } : null;
      }
      if ((m = value.match(/^(?:[a-z]+ )?(\d{1,2})(?:st|nd|rd|th)? ([a-z]{3,9})\.? (\d{4})(.*)$/))) {
        var month2 = MONTHS.indexOf(m[2].slice(0, 3)) + 1;
        return month2 ? { y: +m[3], m: month2, d: +m[1], rest: m[4] } : null;
      }
      return null;
    }

    // Reads a time like "9", "9am", "9:30 pm", "21:30", "noon". Returns [h, m, s] or null.
    function parseTimePart(value) {
      value = value.trim().replace(/^(?:t|at|@)\s*/, '');
      if (value === '' || value === 'midnight') return [0, 0, 0];
      if (value === 'noon') return [12, 0, 0];
      var m = value.match(/^(\d{1,2})(?::(\d{2}))?(?::(\d{2}))?\s*(a\.?m\.?|p\.?m\.?)?$/);
      if (!m) return null;
      var h = +m[1];
      var meridiem = m[4] && m[4].charAt(0);
      if (meridiem) {
        if (h < 1 || h > 12) return null;
        h = (h % 12) + (meridiem === 'p' ? 12 : 0);
      }
      var min = +(m[2] || 0);
      var sec = +(m[3] || 0);
      return h < 24 && min < 60 && sec < 60 ? [h, min, sec] : null;
    }

    // Parses a wall-clock date/time in `timeZone`; returns a UTC timestamp or NaN.
    // Accepts e.g. "2026-11-27 09:00", "11/27/2026 9am", "Nov 27, 2026 9:30 PM", "Friday 27 November 2026 noon".
    function parseStart(value, timeZone) {
      value = (value || '').toLowerCase().replace(/,/g, ' ').replace(/\s+/g, ' ').trim();
      var date = value && parseDatePart(value);
      var time = date && parseTimePart(date.rest);
      if (!time) return NaN;
      var wallClock = Date.UTC(date.y, date.m - 1, date.d, time[0], time[1], time[2]);
      var check = new Date(wallClock);
      if (check.getUTCMonth() !== date.m - 1 || check.getUTCDate() !== date.d) return NaN;
      try {
        var guess = wallClock - zoneOffset(wallClock, timeZone);
        return wallClock - zoneOffset(guess, timeZone);
      } catch (error) {
        return NaN;
      }
    }

    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    var timeFormat = new Intl.DateTimeFormat(undefined, { hour: 'numeric', minute: '2-digit' });
    var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function addToCart(button) {
      var original = button.innerHTML;
      var variantId = Number(button.dataset.hdtAdd);
      button.disabled = true;
      button.textContent = 'Adding…';

      fetch(cartRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      })
        .then(function (response) {
          return response.json().then(function (body) {
            if (!response.ok) throw new Error(body.description || body.message || 'Could not add to cart');
            return fetch(cartRoot + 'cart.js', { headers: { Accept: 'application/json' } });
          });
        })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          // Same shape as the theme's CartAddEvent, so the cart drawer and cart count update.
          button.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId: String(variantId),
                data: {
                  source: 'hourly-deals-timer',
                  itemCount: cart.item_count,
                  productId: button.dataset.productId,
                  variantId: String(variantId),
                },
              },
            })
          );
          button.textContent = 'Added ✓';
          setTimeout(function () {
            button.innerHTML = original;
            button.disabled = false;
          }, 2000);
        })
        .catch(function (error) {
          button.textContent = error.message;
          setTimeout(function () {
            button.innerHTML = original;
            button.disabled = false;
          }, 3000);
        });
    }

    // UTC timestamp for a wall-clock time (expressed as a UTC ms value) in `timeZone`.
    function wallToUtc(wallClock, timeZone) {
      var guess = wallClock - zoneOffset(wallClock, timeZone);
      return wallClock - zoneOffset(guess, timeZone);
    }

    // Midnight at the end of the day that `utcMs` falls on, in `timeZone`.
    function endOfDay(utcMs, timeZone) {
      var wall = new Date(utcMs + zoneOffset(utcMs, timeZone));
      return wallToUtc(Date.UTC(wall.getUTCFullYear(), wall.getUTCMonth(), wall.getUTCDate() + 1), timeZone);
    }

    function init(root) {
      if (!root || root.dataset.hdtReady) return;
      root.dataset.hdtReady = 'true';

      var designMode = !!(window.Shopify && window.Shopify.designMode);
      var timeZone = root.dataset.timezone || 'America/New_York';
      var start = parseStart(root.dataset.start, timeZone);
      var slotMs = (parseInt(root.dataset.slotMinutes, 10) || 60) * 60000;
      var slots = root.querySelectorAll('[data-hdt-slot]');
      var pills = root.querySelectorAll('[data-hdt-pill]');
      var label = root.querySelector('[data-hdt-label]');
      var digits = {
        h: root.querySelector('[data-hdt-h]'),
        m: root.querySelector('[data-hdt-m]'),
        s: root.querySelector('[data-hdt-s]'),
      };
      var timer = root.querySelector('.hdt__timer');
      var tag = root.querySelector('[data-hdt-tag]');
      var schedule = root.querySelector('[data-hdt-schedule]');
      var message = root.querySelector('[data-hdt-message]');
      var status = root.querySelector('[data-hdt-status]');
      var forcedSlot = null;
      var chosenSlot = null;
      var shownSlot;

      var lastDrop = start + (slots.length - 1) * slotMs;
      var end = parseStart(root.dataset.end, timeZone);
      if (isNaN(end)) end = isNaN(start) ? NaN : endOfDay(start, timeZone);
      end = Math.max(end, lastDrop + slotMs);

      root.addEventListener('click', function (event) {
        var button = event.target.closest('[data-hdt-add]');
        if (button && !button.disabled) addToCart(button);

        var tab = event.target.closest('[data-hdt-tab]');
        if (tab && !tab.disabled) {
          chosenSlot = parseInt(tab.closest('[data-hdt-pill]').dataset.hdtPill, 10);
          render();
        }
      });

      if (status) {
        var invalid = isNaN(start);
        status.classList.toggle('hdt__notice--error', invalid && !!root.dataset.start);
        if (!root.dataset.start) {
          status.textContent = 'Hourly deals: set a first drop date and time to schedule this section. It stays hidden on the storefront until you do.';
        } else if (invalid) {
          status.textContent =
            'Hourly deals: couldn\'t read the first drop time "' + root.dataset.start + '". Try something like "Nov 27 2026 9:00 AM" or "2026-11-27 09:00".';
        } else {
          var zoned = new Intl.DateTimeFormat(undefined, {
            timeZone: timeZone,
            weekday: 'short',
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            timeZoneName: 'short',
          });
          status.textContent =
            'Hourly deals: ' + slots.length + (slots.length === 1 ? ' drop' : ' drops') + ', every ' + slotMs / 60000 + ' min. ' +
            'First drop ' + zoned.format(new Date(start)) + ', last drop ' + zoned.format(new Date(lastDrop)) +
            ', all deals end ' + zoned.format(new Date(end)) +
            (root.dataset.end && isNaN(parseStart(root.dataset.end, timeZone)) ? ' (couldn\'t read the end time, so using midnight)' : '') +
            '. Only visible in the editor.';
        }
      }

      function setClock(ms) {
        if (ms === null) {
          digits.h.textContent = digits.m.textContent = digits.s.textContent = '--';
          return;
        }
        var total = Math.max(0, Math.ceil(ms / 1000));
        digits.h.textContent = pad(Math.floor(total / 3600));
        digits.m.textContent = pad(Math.floor((total % 3600) / 60));
        digits.s.textContent = pad(total % 60);
      }

      function setTag(text, muted) {
        tag.hidden = !text;
        tag.classList.toggle('hdt__tag--muted', !!muted);
        tag.textContent = text || '';
      }

      function slotLabel(index) {
        return slots[index] ? slots[index].dataset.hdtSlotLabel : '';
      }

      // latest: newest unlocked drop (-1 for none). next: the drop being counted down to (-1 for none).
      // progress: 0–1 through the wait for `next`. justDropped: badge the latest drop as new.
      function update(shown, latest, next, progress, justDropped) {
        slots.forEach(function (slot, i) {
          slot.hidden = i !== shown;
        });

        pills.forEach(function (pill, i) {
          var tab = pill.querySelector('[data-hdt-tab]');
          var state = pill.querySelector('[data-hdt-step-state]');
          var fill = pill.querySelector('[data-hdt-fill]');
          var unlocked = i <= latest;
          pill.classList.toggle('is-unlocked', unlocked);
          pill.classList.toggle('is-locked', !unlocked);
          pill.classList.toggle('is-selected', i === shown);
          pill.classList.toggle('is-latest', unlocked && justDropped && i === latest);
          pill.classList.toggle('is-next', i === next);
          tab.disabled = !unlocked;
          tab.setAttribute('aria-selected', String(i === shown));
          fill.style.width = i === next ? progress * 100 + '%' : '';
          state.textContent = unlocked ? (justDropped && i === latest ? 'Just dropped' : 'Live') : i === next ? 'Up next' : '';
        });

        if (shown !== shownSlot) {
          shownSlot = shown;
          var current = pills[shown === null ? next : shown];
          if (schedule && current && schedule.scrollWidth > schedule.clientWidth) {
            var scheduleBox = schedule.getBoundingClientRect();
            var stepBox = current.getBoundingClientRect();
            schedule.scrollLeft += stepBox.left - scheduleBox.left - (scheduleBox.width - stepBox.width) / 2;
          }
        }
      }

      if (!slots.length || isNaN(start)) {
        root.hidden = !designMode || !slots.length;
        setClock(null);
        setTag(designMode && slots.length ? 'Editor preview · ' + slotLabel(0) : '', true);
        if (designMode && slots.length) update(0, -1, -1, 0, false);
        return;
      }

      pills.forEach(function (pill, i) {
        var time = pill.querySelector('[data-hdt-pill-time]');
        if (time) time.textContent = timeFormat.format(new Date(start + i * slotMs));
      });

      function render() {
        var now = Date.now();
        if (schedule) schedule.hidden = forcedSlot === null && now >= end;

        if (forcedSlot !== null) {
          root.hidden = false;
          message.hidden = true;
          timer.hidden = false;
          label.textContent = 'Editor preview';
          setClock(null);
          setTag('Editor preview · ' + slotLabel(forcedSlot), true);
          update(forcedSlot, slots.length - 1, -1, 0, false);
          return;
        }

        if (now < start) {
          root.hidden = root.dataset.beforeStart !== 'countdown' && !designMode;
          timer.hidden = false;
          message.hidden = true;
          label.textContent = root.dataset.labelUpcoming;
          setClock(start - now);
          setTag('Starting soon', true);
          update(designMode ? 0 : null, -1, 0, 0, false);
          return;
        }

        if (now >= end) {
          root.hidden = root.dataset.afterEnd !== 'message' && !designMode;
          timer.hidden = true;
          message.hidden = false;
          setTag('', false);
          update(null, slots.length - 1, -1, 0, false);
          return;
        }

        var latest = Math.min(Math.floor((now - start) / slotMs), slots.length - 1);
        var dropping = now < lastDrop;
        var shown = chosenSlot !== null && chosenSlot <= latest ? chosenSlot : latest;

        root.hidden = false;
        message.hidden = true;
        timer.hidden = false;

        if (dropping) {
          var nextDrop = start + (latest + 1) * slotMs;
          label.textContent = root.dataset.labelCurrent;
          setClock(nextDrop - now);
          setTag(latest + 1 + ' of ' + slots.length + ' drops live', false);
          update(shown, latest, latest + 1, 1 - (nextDrop - now) / slotMs, true);
        } else {
          label.textContent = root.dataset.labelFinal;
          setClock(end - now);
          setTag(slots.length === 1 ? 'Live today' : 'All ' + slots.length + ' drops live', false);
          update(shown, latest, -1, 0, false);
        }
      }

      render();
      root._hdtInterval = setInterval(render, 1000);
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) render();
      });

      if (designMode) {
        root._hdtSelect = function (event) {
          var slot = event.target.closest && event.target.closest('[data-hdt-slot]');
          if (!slot || !root.contains(slot)) return;
          forcedSlot = parseInt(slot.dataset.hdtSlot, 10);
          render();
        };
        root._hdtDeselect = function () {
          forcedSlot = null;
          render();
        };
        document.addEventListener('shopify:block:select', root._hdtSelect);
        document.addEventListener('shopify:block:deselect', root._hdtDeselect);
      }
    }

    function teardown(root) {
      if (!root) return;
      clearInterval(root._hdtInterval);
      if (root._hdtSelect) document.removeEventListener('shopify:block:select', root._hdtSelect);
      if (root._hdtDeselect) document.removeEventListener('shopify:block:deselect', root._hdtDeselect);
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.hdt').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      teardown(event.target.querySelector('.hdt'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Collection filtering functionality
  document.addEventListener('DOMContentLoaded', function() {
    const resultsList = document.querySelector('results-list');
    const productGrid = document.querySelector('.product-grid-container');
    
    if (!resultsList || !productGrid) return;

    // Listen for collection filter changes
    document.addEventListener('collection-filter-change', function(event) {
      const { collectionHandle, collectionTitle } = event.detail;
      
      // Update URL without page reload
      const newUrl = new URL(window.location);
      newUrl.searchParams.set('collection', collectionHandle);
      window.history.pushState({}, '', newUrl);
      
      // Filter products
      filterProductsByCollection(collectionHandle, collectionTitle);
    });

    function filterProductsByCollection(collectionHandle, collectionTitle) {
      const productItems = productGrid.querySelectorAll('.product-grid__item');
      
      // Handle "Show All" case
      if (collectionHandle === 'all') {
        productItems.forEach(item => {
          item.style.display = '';
          item.classList.remove('filtered-out');
        });
        return;
      }
      
      const loadingIndicator = createLoadingIndicator();
      
      // Show loading
      productGrid.appendChild(loadingIndicator);
      
      // Hide all products initially
      productItems.forEach(item => {
        item.style.display = 'none';
        item.classList.add('filtered-out');
      });

      // Fetch products for the selected collection
      fetchCollectionProducts(collectionHandle)
        .then(products => {
          // Remove loading indicator
          if (loadingIndicator.parentNode) {
            loadingIndicator.parentNode.removeChild(loadingIndicator);
          }
          
          // Show products that match the collection
          products.forEach(product => {
            const productItem = productGrid.querySelector(`[data-product-id="${product.id}"]`);
            if (productItem) {
              productItem.style.display = '';
              productItem.classList.remove('filtered-out');
            }
          });
          
          // Update results count
        })
        .catch(error => {
          console.error('Error filtering products:', error);
          // Show all products on error
          productItems.forEach(item => {
            item.style.display = '';
            item.classList.remove('filtered-out');
          });
        });
    }

    function fetchCollectionProducts(collectionHandle) {
      return fetch(`/collections/${collectionHandle}/products.json`)
        .then(response => response.json())
        .then(data => data.products || []);
    }

    function createLoadingIndicator() {
      const indicator = document.createElement('div');
      indicator.className = 'collection-filter-loading';
      indicator.innerHTML = `
        <div style="text-align: center; padding: 2rem;">
          <div style="display: inline-block; width: 20px; height: 20px; border: 2px solid #f3f3f3; border-top: 2px solid #333; border-radius: 50%; animation: spin 1s linear infinite;"></div>
          <p style="margin-top: 1rem;">Loading products...</p>
        </div>
      `;
      return indicator;
    }

    // Handle browser back/forward buttons
    window.addEventListener('popstate', function(event) {
      const urlParams = new URLSearchParams(window.location.search);
      const collectionParam = urlParams.get('collection');
      
      if (collectionParam) {
        // Find and trigger the corresponding filter tab
        const filterTab = document.querySelector(`[data-collection-handle="${collectionParam}"]`);
        if (filterTab) {
          filterTab.click();
        }
      } else {
        // Show all products and activate "Show All" tab
        const productItems = productGrid.querySelectorAll('.product-grid__item');
        productItems.forEach(item => {
          item.style.display = '';
          item.classList.remove('filtered-out');
        });
        
        // Remove active class from all filter tabs
        document.querySelectorAll('.collection-filter-tab').forEach(tab => {
          tab.classList.remove('active');
        });
        
        // Activate "Show All" tab
        const showAllTab = document.querySelector('.show-all-tab');
        if (showAllTab) {
          showAllTab.classList.add('active');
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-product-list"] && !Shopify.designMode) return;
  try {
    
    const url = new URL(window.location.href);
    if (url.hash) {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          const card = document.getElementById(url.hash.slice(1));
          if (card) {
            card.scrollIntoView({ behavior: 'instant' });
          }
        },
        { once: true }
      );
    }
  
    // Collection filtering functionality
    document.addEventListener('DOMContentLoaded', function() {
      const resultsList = document.querySelector('results-list');
      const productGrid = document.querySelector('.product-grid-container');
      
      if (!resultsList || !productGrid) return;
  
      // Listen for collection filter changes
      document.addEventListener('collection-filter-change', function(event) {
        const { collectionHandle, collectionTitle } = event.detail;
        
        // Update URL without page reload
        const newUrl = new URL(window.location);
        newUrl.searchParams.set('collection', collectionHandle);
        window.history.pushState({}, '', newUrl);
        
        // Filter products
        filterProductsByCollection(collectionHandle, collectionTitle);
      });
  
      function filterProductsByCollection(collectionHandle, collectionTitle) {
        const productItems = productGrid.querySelectorAll('.product-grid__item');
        
        // Handle "Show All" case
        if (collectionHandle === 'all') {
          productItems.forEach(item => {
            item.style.display = '';
            item.classList.remove('filtered-out');
          });
          return;
        }
        
        const loadingIndicator = createLoadingIndicator();
        
        // Show loading
        productGrid.appendChild(loadingIndicator);
        
        // Hide all products initially
        productItems.forEach(item => {
          item.style.display = 'none';
          item.classList.add('filtered-out');
        });
  
        // Fetch products for the selected collection
        fetchCollectionProducts(collectionHandle)
          .then(products => {
            // Remove loading indicator
            if (loadingIndicator.parentNode) {
              loadingIndicator.parentNode.removeChild(loadingIndicator);
            }
            
            // Show products that match the collection
            products.forEach(product => {
              const productItem = productGrid.querySelector(`[data-product-id="${product.id}"]`);
              if (productItem) {
                productItem.style.display = '';
                productItem.classList.remove('filtered-out');
              }
            });
            
            // Update results count
          })
          .catch(error => {
            console.error('Error filtering products:', error);
            // Show all products on error
            productItems.forEach(item => {
              item.style.display = '';
              item.classList.remove('filtered-out');
            });
          });
      }
  
      function fetchCollectionProducts(collectionHandle) {
        return fetch(`/collections/${collectionHandle}/products.json`)
          .then(response => response.json())
          .then(data => data.products || []);
      }
  
      function createLoadingIndicator() {
        const indicator = document.createElement('div');
        indicator.className = 'collection-filter-loading';
        indicator.innerHTML = `
          <div style="text-align: center; padding: 2rem;">
            <div style="display: inline-block; width: 20px; height: 20px; border: 2px solid #f3f3f3; border-top: 2px solid #333; border-radius: 50%; animation: spin 1s linear infinite;"></div>
            <p style="margin-top: 1rem;">Loading products...</p>
          </div>
        `;
        return indicator;
      }
  
      // Handle browser back/forward buttons
      window.addEventListener('popstate', function(event) {
        const urlParams = new URLSearchParams(window.location.search);
        const collectionParam = urlParams.get('collection');
        
        if (collectionParam) {
          // Find and trigger the corresponding filter tab
          const filterTab = document.querySelector(`[data-collection-handle="${collectionParam}"]`);
          if (filterTab) {
            filterTab.click();
          }
        } else {
          // Show all products and activate "Show All" tab
          const productItems = productGrid.querySelectorAll('.product-grid__item');
          productItems.forEach(item => {
            item.style.display = '';
            item.classList.remove('filtered-out');
          });
          
          // Remove active class from all filter tabs
          document.querySelectorAll('.collection-filter-tab').forEach(tab => {
            tab.classList.remove('active');
          });
          
          // Activate "Show All" tab
          const showAllTab = document.querySelector('.show-all-tab');
          if (showAllTab) {
            showAllTab.classList.add('active');
          }
        }
      });
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Wait for Swiper to exist (timeout after ~5s)
  function waitForSwiper(cb) {
    var attempts = 0;
    var id = setInterval(function () {
      attempts++;
      if (window.Swiper) {
        clearInterval(id);
        cb();
      } else if (attempts > 50) {
        clearInterval(id);
        console.error('Swiper not found. Make sure the Swiper script is loaded before this section script.');
      }
    }, 100);
  }

  // store instances here
  window._productSliders = window._productSliders || {};

  function initSliderForSection(sectionEl) {
    if (!sectionEl) return;

    // Use data-section-id if present, otherwise generate key from element index
    var sectionId = sectionEl.dataset.sectionId || sectionEl.dataset.id || sectionEl.getAttribute('data-id') || null;
    var key = sectionId || Array.prototype.indexOf.call(document.querySelectorAll('.product-new-slider'), sectionEl);

    // If already initialized, destroy first
    if (window._productSliders[key] && window._productSliders[key].destroy) {
      try {
        window._productSliders[key].destroy(true, true);
      } catch (err) {
        console.warn('Error destroying previous swiper instance:', err);
      }
      delete window._productSliders[key];
    }

    var swiperEl = sectionEl.querySelector('.product-new-slider-swiper');
    if (!swiperEl) {
      console.warn('Swiper container not found in section', key);
      return;
    }

    var nextBtn = sectionEl.querySelector('.swiper-button-next');
    var prevBtn = sectionEl.querySelector('.swiper-button-prev');
    var scrollbarEl = sectionEl.querySelector('.swiper-scrollbar');

    // Build config
    var config = {
      slidesPerView: 1.5,
      spaceBetween: 16,
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      breakpoints: {
        320: { slidesPerView: 1.5, spaceBetween: 16 },
        640: { slidesPerView: 2, spaceBetween: 16 },
        768: { slidesPerView: 3, spaceBetween: 16 },
        1024: { slidesPerView: 4, spaceBetween: 16 }
      }
    };

    if (scrollbarEl) {
      config.scrollbar = { el: scrollbarEl, draggable: true };
    }

    // For navigation, pass DOM elements (scoped to this section)
    if (nextBtn && prevBtn) {
      config.navigation = { nextEl: nextBtn, prevEl: prevBtn };
    }

    try {
      var instance = new Swiper(swiperEl, config);
      window._productSliders[key] = instance;
    } catch (err) {
      console.error('Failed to initialize Swiper for section', key, err);
    }
  }

  function initAll() {
    document.querySelectorAll('.product-new-slider').forEach(function (el) {
      initSliderForSection(el);
    });
  }

  // Boot sequence
  waitForSwiper(function () {
    // initialize on load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Shopify theme editor events (reinit / unload)
    document.addEventListener('shopify:section:load', function (e) {
      // e.detail.sectionId exists when Editor loads a single section
      // re-init everything to be safe; or you can target e.detail.sectionId
      initAll();
    });

    document.addEventListener('shopify:section:unload', function (e) {
      // destroy instance for removed section
      var sid = e.detail && e.detail.sectionId;
      if (sid && window._productSliders && window._productSliders[sid]) {
        try { window._productSliders[sid].destroy(true, true); } catch (err) { /* ignore */ }
        delete window._productSliders[sid];
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-pills"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Tag-based product filtering functionality
  document.addEventListener('DOMContentLoaded', function() {
    const productGrid = document.querySelector('.product-grid-container');
    const tagFilterSection = document.querySelector('[data-tag-filter-section]');

    if (!productGrid || !tagFilterSection) {
      console.error('Required elements not found. Check that show_tag_filter is enabled.');
      return;
    }

    const pills = tagFilterSection.querySelectorAll('[data-filter-tag]');
    const productItems = productGrid.querySelectorAll('[data-product-tags]');

    if (pills.length === 0) {
      console.warn('No pills found. Make sure tag values are set in the theme editor.');
    }

    pills.forEach((pill, index) => {
      pill.addEventListener('click', function() {
        const selectedTag = this.getAttribute('data-filter-tag');

        // Update active pill
        pills.forEach(p => {
          p.classList.remove('tag-filter-pill--active');
          // Reset to inactive colors from data attributes
          const inactiveBg = p.getAttribute('data-inactive-bg');
          const inactiveText = p.getAttribute('data-inactive-text');
          const inactiveBorder = p.getAttribute('data-inactive-border');

          if (inactiveBg) p.style.backgroundColor = inactiveBg;
          if (inactiveText) p.style.color = inactiveText;
          if (inactiveBorder) p.style.borderColor = inactiveBorder;
        });

        this.classList.add('tag-filter-pill--active');
        // Set to active colors from data attributes
        const activeBg = this.getAttribute('data-active-bg');
        const activeText = this.getAttribute('data-active-text');
        const activeBorder = this.getAttribute('data-active-border');

        if (activeBg) this.style.backgroundColor = activeBg;
        if (activeText) this.style.color = activeText;
        if (activeBorder) this.style.borderColor = activeBorder;

        // Update URL
        const newUrl = new URL(window.location);
        if (selectedTag === 'all') {
          newUrl.searchParams.delete('tag');
        } else {
          newUrl.searchParams.set('tag', selectedTag);
        }
        window.history.pushState({}, '', newUrl);

        // Filter products
        filterProductsByTag(selectedTag);
      });
    });

    function filterProductsByTag(selectedTag) {
      productItems.forEach((item, index) => {
        const productTags = item.getAttribute('data-product-tags');
        const tagsArray = productTags ? productTags.split(',').map(tag => tag.trim().toLowerCase()) : [];

        if (selectedTag === 'all') {
          item.style.display = '';
          item.classList.remove('tag-filtered-out');
        } else {
          const matches = tagsArray.includes(selectedTag.toLowerCase());
          if (matches) {
            item.style.display = '';
            item.classList.remove('tag-filtered-out');
          } else {
            item.style.display = 'none';
            item.classList.add('tag-filtered-out');
          }
        }
      });
    }

    // Handle browser back/forward buttons
    window.addEventListener('popstate', function() {
      const urlParams = new URLSearchParams(window.location.search);
      const tagParam = urlParams.get('tag');

      if (tagParam) {
        const filterPill = document.querySelector(`[data-filter-tag="${tagParam}"]`);
        if (filterPill) {
          filterPill.click();
        }
      } else {
        const allPill = document.querySelector('[data-filter-tag="all"]');
        if (allPill) {
          allPill.click();
        }
      }
    });

    // Check URL on load for initial filtering
    const urlParams = new URLSearchParams(window.location.search);
    const initialTag = urlParams.get('tag');
    if (initialTag) {
      const filterPill = document.querySelector(`[data-filter-tag="${initialTag}"]`);
      if (filterPill) {
        filterPill.click();
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valentine-custom"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Wait for Swiper to exist (timeout after ~5s)
  function waitForSwiper(cb) {
    var attempts = 0;
    var id = setInterval(function () {
      attempts++;
      if (window.Swiper) {
        clearInterval(id);
        cb();
      } else if (attempts > 50) {
        clearInterval(id);
        console.error('Swiper not found. Make sure the Swiper script is loaded before this section script.');
      }
    }, 100);
  }

  // store instances here
  window._collectionSliders = window._collectionSliders || {};

  function initCollectionSliderForSection(sectionEl) {
    if (!sectionEl) return;

    // Use data-section-id if present, otherwise generate key from element index
    var sectionId = sectionEl.dataset.sectionId || sectionEl.dataset.id || sectionEl.getAttribute('data-id') || null;
    var key = sectionId || Array.prototype.indexOf.call(document.querySelectorAll('.valentine-collection-slider'), sectionEl);

    // If already initialized, destroy first
    if (window._collectionSliders[key] && window._collectionSliders[key].destroy) {
      try {
        window._collectionSliders[key].destroy(true, true);
      } catch (err) {
        console.warn('Error destroying previous swiper instance:', err);
      }
      delete window._collectionSliders[key];
    }

    var swiperEl = sectionEl.querySelector('.valentine-collection-slider-swiper');
    if (!swiperEl) {
      console.warn('Swiper container not found in section', key);
      return;
    }

    var nextBtn = sectionEl.querySelector('.valentine-collection-slider-next');
    var prevBtn = sectionEl.querySelector('.valentine-collection-slider-prev');
    var scrollbarEl = sectionEl.querySelector('.valentine-collection-scrollbar');

    // Build config - exact same as homepage (max 4 slides)
    var config = {
      slidesPerView: 1.5,
      spaceBetween: 16,
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      centeredSlides: false,
      watchOverflow: true,
      breakpoints: {
        320: { slidesPerView: 1.5, spaceBetween: 16 },
        640: { slidesPerView: 2, spaceBetween: 16 },
        768: { slidesPerView: 3, spaceBetween: 16 },
        1024: { slidesPerView: 4, spaceBetween: 16 }
      }
    };

    if (scrollbarEl) {
      config.scrollbar = { el: scrollbarEl, draggable: true };
    }

    // For navigation, pass DOM elements (scoped to this section)
    if (nextBtn && prevBtn) {
      config.navigation = { nextEl: nextBtn, prevEl: prevBtn };
    }

    try {
      var instance = new Swiper(swiperEl, config);
      window._collectionSliders[key] = instance;
    } catch (err) {
      console.error('Failed to initialize Swiper for section', key, err);
    }
  }

  function initAll() {
    document.querySelectorAll('.valentine-collection-slider').forEach(function (el) {
      initCollectionSliderForSection(el);
    });
  }

  // Boot sequence
  waitForSwiper(function () {
    // initialize on load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Shopify theme editor events (reinit / unload)
    document.addEventListener('shopify:section:load', function (e) {
      initAll();
    });

    document.addEventListener('shopify:section:unload', function (e) {
      // destroy instance for removed section
      var sid = e.detail && e.detail.sectionId;
      if (sid && window._collectionSliders && window._collectionSliders[sid]) {
        try { window._collectionSliders[sid].destroy(true, true); } catch (err) { /* ignore */ }
        delete window._collectionSliders[sid];
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
